import {
  Box,
  Button,
  Checkbox,
  Chip,
  FormControl,
  InputLabel,
  ListItemText,
  MenuItem,
  Select,
} from "@mui/material";

import { BudgetDashboardOption } from "../../../types/dashboard";

interface StatusMultiSelectProps {
  options: BudgetDashboardOption[];
  value: string[];
  onChange: (value: string[]) => void;
}

export const StatusMultiSelect = ({
  options,
  value,
  onChange,
}: StatusMultiSelectProps) => {
  const labelById = new Map(options.map((option) => [option.id, option.name]));

  // Filtro vazio significa "todos" para a API, então a lista aparece com tudo
  // marcado: o usuário só desmarca os status que não quer ver.
  const isAllSelected = !value.length;
  const displayedValue = isAllSelected
    ? options.map((option) => option.id)
    : value;

  return (
    <FormControl fullWidth size="small">
      <InputLabel shrink>Status MM</InputLabel>
      <Select
        multiple
        displayEmpty
        notched
        label="Status MM"
        value={displayedValue}
        onChange={(event) => {
          const selected = event.target.value;
          const next =
            typeof selected === "string" ? selected.split(",") : selected;

          // Marcar tudo (ou desmarcar tudo) volta ao estado canônico "Todos".
          onChange(next.length === options.length ? [] : next);
        }}
        renderValue={(selected) => {
          if (!selected.length || selected.length === options.length)
            return "Todos";
          if (selected.length === 1)
            return labelById.get(selected[0]) || selected[0];

          return (
            <Box display="flex" alignItems="center" gap={0.5}>
              <Chip
                size="small"
                label={`${selected.length} selecionados`}
                sx={{ height: 20, fontSize: 11 }}
              />
            </Box>
          );
        }}
        MenuProps={{ PaperProps: { style: { maxHeight: 360 } } }}
      >
        <Box
          display="flex"
          gap={1}
          px={1.5}
          py={1}
          borderBottom="1px solid #E2E8F0"
        >
          <Button
            size="small"
            disabled={isAllSelected}
            onClick={() => onChange([])}
          >
            Selecionar todos
          </Button>
        </Box>
        {options.map((option) => (
          <MenuItem key={option.id} value={option.id} dense>
            <Checkbox
              size="small"
              checked={displayedValue.includes(option.id)}
            />
            <ListItemText primary={option.name} />
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};
